import ActionActor from './ActionActor';

export default ActionActor;
